import { Outlet, Navigate } from 'react-router';
import { isAuthenticated } from '../api/tokenUtils';
import { useAppSelector } from '../redux/hooks';

export default function PublicLayout() {
  const { isAuthenticated: reduxIsAuthenticated, user } = useAppSelector(
    state => state.auth
  );

  if (isAuthenticated() && reduxIsAuthenticated && user) {
    // Navigate based on user role (case-insensitive comparison)
    if (user?.role?.toLowerCase() === 'superadmin') {
      return <Navigate to="/companies" replace />;
    } else {
      return <Navigate to="/api-reference/introduction" replace />;
    }
  }

  return <Outlet />;
}
